import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faExclamationTriangle, faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

import type { ValidateOrderItemError } from '@functions/orderItem'

const statusSettings = {
  invalid: {
    color: 'red',
    icon: faExclamationTriangle,
    text: 'Review Warnings',
  },
  valid: {
    color: 'green',
    icon: faCheck,
    text: 'Ready to Go',
  },
  warning: {
    color: 'orange',
    icon: faInfoCircle,
    text: 'Review Warnings',
  },
}

const getItemStatusKey = (errors: ValidateOrderItemError[]) => {
  if (errors && errors.length){
    const hasBlocker = errors.some(error => error.blocker)
    return hasBlocker ? 'invalid' : 'warning'
  }

  return 'valid'
}

interface ItemHeaderProps {
  errors: ValidateOrderItemError[],
  title: string,
}

const ItemHeader = (props: ItemHeaderProps) => {
  const { errors, title } = props

  const itemStatusKey = getItemStatusKey(errors)
  const { color, icon, text } = statusSettings[itemStatusKey] || {}

  return (
    <Box
      alignItems="center"
      borderBottom="1px dashed"
      borderColor="lineColor"
      justifyContent="space-between"
      paddingBottom="large"
    >
      <Text>{title}</Text>

      <Text color={color} fontSize="xsmall">
        <FontAwesomeIcon icon={icon} /> {text}
      </Text>
    </Box>
  )
}

export default ItemHeader
